// extracted by mini-css-extract-plugin
export default {"ctaSection":"CTASection_ctaSection__Ju9c+"};